
(function authNotificationConfigModuleDefinition() {

    'use strict';
    
    angular.module('AuthNotificationConfig', ['ui.router', 'Config', 'Entities', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function authNotificationConfig(config, $stateProvider, loginProvider) {
                     
                $stateProvider.state('auth-notification-config-find', {
                    url: "/AuthNotificationConfig/List",
                    templateUrl: config.resourceUrl('/views/auth-notification-config/list.html'),
                    controller: 'AuthNotificationConfigFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('AUTH NOTIFICATION READ').or('AUTH NOTIFICATION WRITE') 
                });

                $stateProvider.state('auth-notification-config-add', {
                    url: "/AuthNotificationConfig/Add",
                    templateUrl: config.resourceUrl('/views/auth-notification-config/add.html'),
                    controller: 'AuthNotificationConfigAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('AUTH NOTIFICATION WRITE')
                });

                $stateProvider.state('auth-notification-config-detail', {
                    url: "/AuthNotificationConfig/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/auth-notification-config/detail.html'),
                    controller: 'AuthNotificationConfigDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('AUTH NOTIFICATION READ').or('AUTH NOTIFICATION WRITE') 
                });
            }
        ]);
})();